var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.open ? 'swiper-slide open' : 'swiper-slide',on:{"click":function($event){return _vm.$emit('toggleOpen', _vm.index, $event)}}},[_c('div',{staticClass:"timestamp"},[_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.data.year))])]),_c('div',{staticClass:"status"},[_vm._v(_vm._s(_vm.data.status))])])
}
var staticRenderFns = []

export { render, staticRenderFns }